<template>
  <app-modal
    v-bind="$attrs"
    ref="modal"
    class="modal-container pa-0"
    content-class="modal-large"
    title="お問い合わせ一覧"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <div class="modal-body">
        <v-container>
          <!-- マニュアル案内（固定表示） -->
          <v-card
            class="d-sm-inline-block w-100 pa-5 manual-guide-card"
            variant="outlined"
            color="info"
          >
            <div class="d-flex align-center mb-3">
              <v-icon
                icon="$mdiBookOpenPageVariantOutline"
                class="mr-2"
                color="info"
                size="24"
              ></v-icon>
              <h4 class="text-info">マニュアルのご案内</h4>
            </div>
            <div class="manual-content">
              <p class="mb-2">
                お問い合わせを実施する前にマニュアルをご一読ください。
              </p>
              <div class="mb-3">
                <a
                  href="https://wvs2document.com/pre-top/"
                  target="_blank"
                  class="my-2 text-decoration-none text-info font-weight-bold manual-link"
                >
                  KDDI WVS2 web manual はこちら
                </a>
              </div>
              <div class="additional-info pa-3 bg-grey-lighten-5 rounded">
                <v-icon
                  icon="$mdiInformationOutline"
                  class="mr-1"
                  size="16"
                ></v-icon>
                <span class="text-body-2">
                  各ページ右上のマニュアルボタン（<v-icon
                    icon="$mdiBookOpenPageVariantOutline"
                    size="16"
                    class="mx-1"
                  ></v-icon
                  >）をクリックすると、操作中の画面に関するマニュアルが表示されます。<br />そちらから操作方法をご確認いただけます。
                </span>
              </div>
            </div>
          </v-card>

          <v-card
            class="d-sm-inline-block w-100 mt-4 pa-5"
            variant="outlined"
            v-for="(e, i) in specialNotes"
            :key="i"
          >
            <h4 class="mb-2">{{ e.title }}</h4>
            <div class="inq">{{ e.body }}</div>
            <div class="inq" v-if="e.linkUrl">
              <template v-if="e.linkUrl.startsWith('mailto:')"
                >E-mail :
              </template>
              <template v-else-if="e.linkUrl.includes('document')"> </template>
              <template v-else>URL :</template>
              <a
                :href="e.linkUrl"
                target="_brank"
                class="text-decoration-none"
                >{{ e.linkTitle ? e.linkTitle : e.linkUrl }}</a
              >
            </div>
          </v-card>
        </v-container>
      </div>

      <v-divider></v-divider>

      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { SpecialNote } from "@/apis/InformationApi";

export default defineComponent({
  name: "ContactUsReference",
  data() {
    return {
      isLoaded: false,
      // 特記事項
      specialNotes: [] as SpecialNote[],
    };
  },
  async mounted() {
    await this.load();
    this.isLoaded = true;
  },
  methods: {
    /** 読み込み */
    async load() {
      this.specialNotes = await this.$api.information.getSpecialNotes();
    },
  },
});
</script>
<style lang="scss" scoped>
.manual-guide-card {
  border: 2px solid rgb(var(--v-theme-info)) !important;
  background: linear-gradient(
    135deg,
    rgba(var(--v-theme-info), 0.05),
    rgba(var(--v-theme-info), 0.1)
  );

  .manual-content {
    line-height: 1.6;

    p {
      font-weight: 500;
    }

    .manual-link {
      position: relative;
      padding: 8px 16px 8px 8px;
      border-radius: 4px;
      background: rgba(var(--v-theme-info), 0.1);
      border: 1px solid rgba(var(--v-theme-info), 0.3);
      transition: all 0.2s ease;

      &:hover {
        background: rgba(var(--v-theme-info), 0.2);
        border-color: rgb(var(--v-theme-info));
        text-decoration: underline !important;
      }
    }

    .additional-info {
      border-left: 4px solid rgb(var(--v-theme-info));
    }
  }
}

.inq {
  line-height: 2;
  white-space: pre-line;
}
</style>
